import type { JSX } from "react";
import { useQuery } from "urql";
import Loader from "../../shared/components/Loader";
import RenderMark from "../../shared/components/RenderMark";
import ShowError from "../components/ShowError";
import { query } from "./queries";

function Terms(): JSX.Element {
    const [result] = useQuery({ query });

    if (result.fetching) {
        return <Loader />;
    }
    if (result.error) {
        return <ShowError />;
    }
    return (
        <>
            <section>
                <RenderMark content={result.data.terms.settingsTerms} unsafe />
            </section>
            <section>
                <RenderMark content={result.data.terms.terms} unsafe />
            </section>
        </>
    );
}

export default Terms;
